import { Logo, Stack } from "@octopus-energy/coral/atoms"
import {
    Header,
    HeaderLogoNavigation,
    HeaderMenuToggleButton,
    HeaderNavMenu,
} from "@octopus-energy/coral/organisms"
import { useLocale, useTranslations } from "next-intl"
import { storyblokRoutesPaths } from "@/routes/storyblok"
import { useNavigationMenu } from "../../hooks/useNavigationMenu"
import { useUserHeader } from "../../hooks/useUserHeader"
import { AccountMenu } from "./AccountMenu"
import { DashboardMenu } from "./DashboardMenu"
import { NavigationMenuList } from "./NavigationMenuList"

export function AppHeader() {
    const t = useTranslations("AppHeader")
    const logoLink = storyblokRoutesPaths.home.resolve()
    const locale = useLocale()

    const user = useUserHeader()
    const navigationMenu = useNavigationMenu()

    return (
        <Header
            currentLocale={locale}
            user={user}
        >
            <Stack
                justifyContent="space-between"
                fullWidth
            >
                <HeaderLogoNavigation>
                    <Logo
                        href={logoLink}
                        hrefSrLabel={t("home")}
                        variant="logomark"
                        width={24}
                    />
                    <HeaderMenuToggleButton
                        closedText={t("closedText")}
                        openText={t("closedText")}
                    />
                    <HeaderNavMenu>
                        <DashboardMenu.Mobile />
                        <NavigationMenuList items={navigationMenu} />
                    </HeaderNavMenu>
                </HeaderLogoNavigation>
                <Stack
                    justifyContent="flex-end"
                    alignItems="center"
                >
                    <AccountMenu.Desktop />
                </Stack>
            </Stack>
        </Header>
    )
}

AppHeader.messages = [
    "AppHeader",
    ...AccountMenu.messages,
    ...useNavigationMenu.messages,
    ...useUserHeader.messages,
] as const
